import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    handleSliderChange(values) {
        this.props.dispatch(Action.set('LineupsQuantity', parseInt(values[0])));
    }

    render() {
        const {lineupsQuantity, step = 1} = this.props;

        const currentValue = lineupsQuantity.getLineupsQuantity();
        const minVal = lineupsQuantity.getMinBoundary();
        const maxVal = lineupsQuantity.getMaxBoundary();

        return (
            <SliderAdapter
                key={`slider-${currentValue}`}
                onChange={::this.handleSliderChange}
                min={minVal}
                max={maxVal}
                defaultValue={currentValue}
                thumb={<div className="circle"></div>}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {lineupsQuantity} = state;
    return {
        lineupsQuantity,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
